import React from 'react';
import PropTypes from 'prop-types';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { InputField } from '@jutro/legacy/components';
import { Position } from 'wmic-pe-portals-utils-js';
import metadata from './WMICIterableDriverComponent.metadata.json5';
import styles from './WMICIterableDriverComponent.module.scss';
import './WMICIterableDriverComponent.messages';

function WMICIterableDriverComponent(props) {
    const { driver } = props;

    const overrides = {
        '@field': {
            parentNode: driver,
            readOnly: true,
            labelPosition: Position.TOP,
        },
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            InputField,
        },
    };

    return (
        <ViewModelForm
            model={driver}
            overrideProps={overrides}
            uiProps={metadata.componentContent}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

WMICIterableDriverComponent.propTypes = {
    value: PropTypes.shape({}).isRequired,
};

export default WMICIterableDriverComponent;
